import React from 'react';
import MultiCellProgressBar from './MultiCellProgressBar';

const DimensionTableCell = ({ key, data }) => {
    const { grouping, question, perceptionData, shift } = data;
    return (
        <tr
            tabIndex={-1}
            key={key}
        >
            <td width="10%">{grouping}</td>
            <td width="45%">{question}</td>
            <td width="40%">
                <div className="user-profile d-flex flex-row align-items-center">
                    <div className="user-detail">
                        <h5 className="user-name"><MultiCellProgressBar key={key} data={perceptionData} /></h5>
                    </div>
                </div>
            </td>
            <td width="5%">{shift}</td>
        </tr>

    );
};

export default DimensionTableCell;



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTableCell.js